// Expense Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get expenseList from backend then update expenseList in vuex store ***** //
export const updateExpenseList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      ...payload.advancedSearch,
      is_filtered: payload.isFiltered
    }
  }

  try {
    const result = await Axios.get('expenditure_index', { params: params })
    const resultData = result.data.data
    let resultWithFooter = resultData.data
    resultWithFooter.footer = resultData.footer
    commit('updateExpenseList', resultWithFooter)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get reportExpenseList from backend then update reportExpenseList in vuex store ***** //
export const updateReportExpenseList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      outlet_id: payload.id,
      ...payload.advancedSearch,
      is_filtered: payload.isFiltered
    }
  }

  try {
    const result = await Axios.get(`report_expenses/${payload.id}`, { params: params })
    const resultData = result.data.data
    let resultWithFooter = resultData.data
    resultWithFooter.footer = resultData.footer
    commit('updateExpenseList', resultWithFooter)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch Expense from backend ***** //
export const fetchExpenseInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`expenditure_show/${payload}`)
    commit('fetchExpenseInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Expense  ***** //
export const addExpense = async (ignored, payload = null) => {
  try {
    await Axios.post('expenditure_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Expense  info ***** //
export const updateExpenseInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`expenditure_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Expense  ***** //
export const deleteExpense = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`expenditure_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
